import React from "react";

class Page5 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 5) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Understanding Strengths</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          We began this pathway by focusing on what motivates
                          you (i.e. your values). In this section we will
                          explore and identify your strengths. Awareness of your
                          values and strengths will ultimately help you to
                          clarify the key criteria that your future career needs
                          to fulfil for you. In other words we are continuing to
                          add to your personal shopping list.
                        </p>
                        <p>
                          It is helpful to start by understanding the difference
                          between strengths, skills and competencies, especially
                          as these words are commonly used in the recruitment
                          process.
                        </p>
                        <p className="text-margin-left">
                          <strong>Strength:</strong> is something that you
                          enjoy, that you&rsquo;re interested in, that engages
                          you and you are naturally good at.
                        </p>
                        <p className="text-margin-left">
                          <strong>Skill:</strong> something you learn to do
                          through repetition for which there is a best practice
                          or a set method, for example coding in a given
                          language or swimming a specific stroke.
                        </p>
                        <p className="text-margin-left">
                          <strong>Competency:</strong> behaviours and skills
                          needed to perform effectively in a role, as defined by
                          employer.
                        </p>
                        <p>
                          According to{" "}
                          <a
                            target="_blank"
                            href="https://news.gallup.com/businessjournal/167462/employees-strengths-company-stronger.aspx"
                          >
                            research by Gallup
                          </a>
                          , people who use their strengths at work are more
                          likely to be engaged and less likely to experience
                          stress and anxiety. Therefore one way of focusing your
                          career thinking is to look for jobs that harness your
                          strengths. On the next page you will be presented with
                          15 strengths that are valued by employers. We&rsquo;d
                          like you to narrow these to 5 personal strengths.
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page5;
